// src/api/client.ts (o donde tengas este wrapper)
import type { AxiosRequestConfig } from "axios";
import apiAxios from "./axios"; // ← tu archivo con interceptores (export default api)

export const api = {
  get: async <T>(url: string, config?: AxiosRequestConfig) =>
    (await apiAxios.get<T>(url, config)).data,

  post: async <T>(url: string, body?: any, config?: AxiosRequestConfig) =>
    (await apiAxios.post<T>(url, body, config)).data,

  put: async <T>(url: string, body?: any, config?: AxiosRequestConfig) =>
    (await apiAxios.put<T>(url, body, config)).data,

  patch: async <T>(url: string, body?: any, config?: AxiosRequestConfig) =>
    (await apiAxios.patch<T>(url, body, config)).data,

  del: async (url: string, config?: AxiosRequestConfig) => {
    await apiAxios.delete(url, config);
  },
};

export default api; // por si alguien hace import default
